import { Icon,Button,Toast,Form,Field,Calendar,DatetimePicker,Popup,Collapse,CollapseItem,Picker,Cell,CellGroup,RadioGroup,Radio,Uploader,Step,Steps,Checkbox,CheckboxGroup,Divider,Panel,ContactCard,CountDown   } from 'vant';


const components = {
  Icon,
  Button,
  Toast,
  Form,
  Field,
  Calendar,
  DatetimePicker,
  Popup,
  Collapse,
  CollapseItem,
  Picker,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Uploader,
  Step,
  Steps,
  Checkbox,
  CheckboxGroup,
  Divider,
  Panel,
  ContactCard,
  CountDown 
}

// 设置 toast 展示时长, 为 0 时不会消失
Toast.setDefaultOptions('loading',{ duration: 0 });

// 全局注册组件
const install = function (Vue) {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
  });
}


export default install;